export const EASE = [0.21, 0.47, 0.32, 0.98];

export const stagger = {
  hidden: {},
  show: { transition: { staggerChildren: 0.06, delayChildren: 0.05 } },
};

export const rise = {
  hidden: { opacity: 0, y: 14 },
  show: { opacity: 1, y: 0, transition: { duration: 0.4, ease: EASE } },
};

export const maskReveal = {
  hidden: { y: "110%" },
  show: { y: 0, transition: { duration: 0.55, ease: EASE } },
};
